type ScrollMetrics = {
  scrollTop: number;
  clientHeight: number;
  scrollHeight: number;
};

export const hasScrolledToDocumentEnd = (
  root: ScrollMetrics,
  thresholdPx = 8,
): boolean =>
  root.scrollTop + root.clientHeight >= root.scrollHeight - thresholdPx;
